import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CategoryService } from '../_services/category.service';
import { DocumentService } from '../_services/document.services';
import { HoldsService } from '../_services/holds.services';
import { VirtualFolderService } from '../_services/virtualFolder.service'

@Component({
  selector: 'app-dialog-delete-confirm',
  templateUrl: './dialog-delete-confirm.component.html',
  styleUrls: ['./dialog-delete-confirm.component.scss']
})
export class DialogDeleteConfirmComponent implements OnInit {

  message: string = null;
  payload: any = null;
  comment: string = null;
  document_id: string = null;
  isCommentRequired: boolean = false;
  isConfiguration: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteConfirmComponent>,
    private documentService: DocumentService,
    private categoryService: CategoryService,
    private holdsService: HoldsService,
    private virtualFolderService: VirtualFolderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    switch (this.data.type) {
      case "Delete Document": this.setDeleteDocument()
        break;
      case "Delete Version": this.setDeleteVersion()
        break;
      case "Activate Version": this.setActivateVersion()
        break;
      case "Delete Category": this.setDeleteCateory()
        break;
      case "Remove Hold": this.setRemoveHold()
        break;
      case "Delete Documents": this.setDeleteDocuments()
        break;
      case "Add Configuration": this.addConfiguration()
        break;
      case "Delete Folder": this.setDeleteFolder()
        break;
    }
  }

  setDeleteFolder(){
    this.message = "Are you sure you wish to delete the folder?"
    this.isCommentRequired = false
    this.isConfiguration = false
  }

  setRemoveHold() {
    this.message = "Are you sure you wish to remove the hold?"
    this.isCommentRequired = false
    this.isConfiguration = false
  }

  removeHold() {
    this.holdsService.removeHold(this.data.payload).subscribe(resp => {
      this.dialogRef.close(true);
    })
  }

  setDeleteCateory() {
    this.message = "Are you sure you wish to delete this Category?"
    this.isCommentRequired = false
    this.isConfiguration = false
  }

  deleteCategory() {
    const payload = this.data.payload
    this.categoryService.deleteCategory(payload).subscribe(resp => {
      this.dialogRef.close(true)
    })
  }

  setDeleteDocument() {
    this.message = "Are you sure you wish to delete this Document?"
    this.document_id = this.data.payload
    this.isCommentRequired = true
    this.isConfiguration = false
  }

  setDeleteDocuments() {
    this.message = "Are you sure you wish to delete these Documents?"
    this.isCommentRequired = false
    this.isConfiguration = false
  }

  addConfiguration() {
    this.message = "Enter attribute and corresponding configuration."
    this.isCommentRequired = false
    this.isConfiguration = true
  }

  deleteDocument() {
    var payload = {}
    if (this.comment != null) {
      payload = {
        comment: this.comment
      }
    }
    this.documentService.deleteDocument(this.document_id, payload).subscribe(resp => {
      //console.log("Response", resp)
      this.dialogRef.close(true)
    })
  }

  deleteDocuments() {
    var check = {}
    console.log("payload", this.data.payload);
    var documentCounter = 0
    this.data.payload.forEach((element) => {
      this.document_id = element;
      this.documentService.deleteDocument(this.document_id, check).subscribe(resp => {
        documentCounter++;
        console.log("documentCounter", documentCounter)
        if (documentCounter == this.data.payload.length) {
          this.dialogRef.close(true)
        }
      })
    });
  }

  deleteVirtualFolder(){
    this.virtualFolderService.deleteFolder(this.data.id).subscribe((resp) => {
      this.dialogRef.close(true)
    });
  }

  deleteVersion() {
    var payload = this.data.payload
    if (this.comment != null) {
      payload = {
        document_id: this.data.payload.document_id,
        version: this.data.payload.version,
        comment: this.comment
      }
    }
    //console.log("Delete Version Payload", payload)
    this.documentService.deleteVersion(payload).subscribe(resp => {
      //console.log("Delete Version response", resp)
      this.dialogRef.close(true)
    })
  }

  setDeleteVersion() {
    this.isCommentRequired = true
    this.isConfiguration = false
    this.message = "Are you sure you wish to delete this version of the document?"
  }

  setActivateVersion() {
    this.isCommentRequired = true
    this.isConfiguration = false
    this.message = "Are you sure you wish to make this the active version?"
  }

  activateVersion() {
    var payload = this.data.payload
    if (this.comment != null) {
      payload = {
        document_id: this.data.payload.document_id,
        version: this.data.payload.version,
        comment: this.comment
      }
    }
    this.documentService.activateVersion(payload).subscribe(resp => {
      this.dialogRef.close(true)
    })
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
